import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure} from "@nextui-org/react";
import axios from "axios";
import { orders_uri } from "../../../../utils/url";
import { toast } from "react-toastify";
import { MdOutlineDeleteOutline } from "react-icons/md";

export default function DeleteModal({data, callback}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  const [pay, setPay] = useState();
  const [load, setLoad] = useState(false);

  const call = () =>{
    callback();
  }

  const Sub = async()=>{
    setLoad(true);
    try{
        const res = await axios.delete(orders_uri+'/delete'+`?id=${data}`);
        if(res.status === 200){
            toast.success("Амжилттай");
            setPay('');
            call();
            setLoad(false);
            onOpenChange(false);
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }


  return (
    <>
      <MdOutlineDeleteOutline onClick={onOpen} className="bg-red-600 rounded-full p-1 cursor-pointer" color="white" size={24}/>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange}>
        <ModalContent>
          {(onClose) => (
            <>
              <ModalHeader className="flex flex-col gap-1">Захиалга устгах</ModalHeader>
              <ModalBody>
                Та устгахдаа итгэлтэй байна уу ?
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Close
                </Button>
                {
                    load?
                    <Button className="bg-blue-300">
                        Устгаж байна ...
                    </Button>
                    :
                    <Button color="primary" onPress={Sub}>
                        Тийм
                    </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}
